"use client";

import { c as _c } from "react/compiler-runtime";
import { InfiniteData, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { queryClient } from "@/config/react-query";
import { ChatDetail, ChatSummary } from "@/types/chat";
import { CursorPage } from "@/types/pagination";
import { chatQueryKeys, chatQueryOptions } from "@/query/comms/chat";
interface UseChatDataOptions {
  chatId: string | null | undefined;
}
interface UseChatDataReturn {
  chatDetail: ChatDetail | null;
  chatSummary: ChatSummary | null;
  chat: ChatDetail | ChatSummary | null;
  messages: ChatDetail["messages"];
  emails: ChatDetail["emails"];
  isLoading: boolean;
  isPending: boolean;
}
export function useChatData(t0) {
  const $ = _c(21);
  const {
    chatId
  } = t0;
  let t1;
  if ($[0] !== chatId) {
    t1 = chatQueryOptions.detail(chatId ?? "");
    $[0] = chatId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!chatId;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: chatDetail,
    isPending
  } = useQuery(t3);
  let t4;
  bb0: {
    if (chatDetail) {
      t4 = null;
      break bb0;
    }
    let t5;
    if ($[5] !== chatId) {
      const key_0 = chatQueryKeys.infiniteList().filter(_temp);
      const chatListQueries = queryClient.getQueriesData({
        queryKey: key_0
      });
      const chatList = chatListQueries.find(t6 => {
        const [, data] = t6;
        return data?.pages.some(page => page.data.some(chat => chat.id === chatId));
      });
      const data_0 = chatList?.[1];
      t5 = data_0?.pages.flatMap(_temp2).find(chat_0 => chat_0.id === chatId);
      $[5] = chatId;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    const matchingChat = t5;
    t4 = matchingChat ?? null;
  }
  const chatSummary = t4;
  const chat_1 = chatDetail ?? chatSummary;
  let t5;
  if ($[7] !== chatDetail?.messages) {
    t5 = () => chatDetail?.messages ?? [];
    $[7] = chatDetail?.messages;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  chatDetail?.messages;
  let t6;
  if ($[9] !== t5) {
    t6 = t5();
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const messages = t6;
  chatDetail?.emails;
  let t7;
  if ($[11] !== chatDetail?.emails) {
    t7 = chatDetail?.emails ?? [];
    $[11] = chatDetail?.emails;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const emails = t7;
  const isLoading = isPending || !chat_1;
  const t8 = chatDetail ?? null;
  let t9;
  if ($[13] !== chatSummary || $[14] !== chat_1 || $[15] !== emails || $[16] !== isLoading || $[17] !== isPending || $[18] !== messages || $[19] !== t8) {
    t9 = {
      chatDetail: t8,
      chatSummary,
      chat: chat_1,
      messages,
      emails,
      isLoading,
      isPending
    };
    $[13] = chatSummary;
    $[14] = chat_1;
    $[15] = emails;
    $[16] = isLoading;
    $[17] = isPending;
    $[18] = messages;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
function _temp2(page_0) {
  return page_0.data;
}
function _temp(key) {
  return key !== undefined;
}